import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule, ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  public currentUrl = '';
  public routeParams;

  constructor(private activeRoute: ActivatedRoute, public router: Router) { }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/breadcrumb/breadcrumb.component.ts